import {
    GET_ALL_MUSEUMS,
    GET_ALL_MUSEUMS_SUCCESS,
    GET_ALL_MUSEUMS_FAIL,
    GET_MUSEUM,
    GET_TOP_MUSEUM,
    GET_TOP_MUSEUM_SUCCESS,
    GET_TOP_MUSEUM_FAIL,
    GET_TOP_ARTISTS_SUCCESS,
    GET_TOP_ARTISTS_FAIL,
    GET_TOP_ARTISTS,
    GET_ALL_ARTISTS_FAIL,
    GET_ALL_ARTISTS,
    GET_ALL_ARTISTS_SUCCESS
} from "./actionTypes";

const INIT_STATE = {
    error: "",
    loading: false,
    museums: [],
    topMuseums: [],
    totalMuseums: 0,
    museum: {},
    topArtist: [],
    allArtists: [],
    totalArtists: 0
};

const Museums = (state = INIT_STATE, action) => {
    switch (action.type) {
        /* Get New Categories */
        case GET_ALL_MUSEUMS:
        case GET_TOP_MUSEUM:
        case GET_ALL_ARTISTS:
            return {
                ...state,
                loading: true,
            };

        case GET_ALL_MUSEUMS_SUCCESS:
            return {
                ...state,
                loading: false,
                musuems: action.payload || [],
            };

        case GET_TOP_MUSEUM_SUCCESS:
            return {
                ...state,
                loading: false,
                topMuseums: action.payload || [],
            };

        case GET_ALL_ARTISTS_SUCCESS:
            return {
                ...state,
                loading: false,
                allArtists: action.payload.data || [],
                totalArtists: action.payload.totalCount || 0
            };

        case GET_ALL_MUSEUMS_FAIL:
        case GET_TOP_MUSEUM_FAIL:
        case GET_ALL_ARTISTS_FAIL:
            return {
                ...state,
                loading: false,
            };

        case GET_MUSEUM:
            return {
                ...state,
                loading: false,
                musuem: action.payload || {},
            };
        case GET_TOP_ARTISTS:
            return {
                ...state,
                loading: true,
            };
        case GET_TOP_ARTISTS_SUCCESS:
            return {
                ...state,
                loading: false,
                topArtist: action.payload || [],
            };
        case GET_TOP_ARTISTS_FAIL:
            return {
                ...state,
                loading: false,
            };
        default:
            return state;
    }
};

export default Museums;
